import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { AuthProvider } from "./context/AuthContext";
import { EmployeesContextProvider } from "./context/EmployeesContext";
import { MessagesContextProvider } from "./context/MessagesContext";
import { ErrorBoundary } from "react-error-boundary";
import { appInsights } from "./telemetry/appInsights";

ReactDOM.render(
  <React.StrictMode>
    <ErrorBoundary
      fallback={<p role="alert">Något gick fel. Uppdatera sidan.</p>}
      onError={(error, errorInfo) => {
        appInsights.trackException({
          exception: error,
          properties: { componentStack: errorInfo.componentStack },
        });
      }}
    >
      <AuthProvider>
        <MessagesContextProvider>
          <EmployeesContextProvider>
            <App />
          </EmployeesContextProvider>
        </MessagesContextProvider>
      </AuthProvider>
    </ErrorBoundary>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
